import { render, staticRenderFns } from "./CreatePlatform.vue?vue&type=template&id=355047d8&scoped=true&"
import script from "./CreatePlatform.vue?vue&type=script&lang=js&"
export * from "./CreatePlatform.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlatform.vue?vue&type=style&index=0&id=355047d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355047d8",
  null
  
)

export default component.exports